import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/HistoryRounded';

class HistoryRoundedIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default HistoryRoundedIcon;
